import { ElementRef, Renderer2 } from '@angular/core';

export interface ISelector {
	show: boolean;
	startX: number;
	startY: number;
	endX: number;
	endY: number;
}
export interface IPoint {
	x: number;
	y: number;
}
export const noneSelector: ISelector = { show: false, startX: -1, startY: -1, endX: -1, endY: -1 };
export const nonePoint: IPoint = { x: -1, y: -1 };
export class Selector {
	renderer: Renderer2;
	closeMouseDownListern: () => void;
	selector: ISelector;
	leftPressed: boolean;
	x: number;
	y: number;
	current: IPoint;
	timer: NodeJS.Timer;
	elRef: ElementRef<HTMLDivElement>;
	tabData: ElementRef<HTMLTableElement>;
	cellSelector(colIndex: number, rowIndex: number) {
		if (!this.selector.show) {
			return false;
		}
		// æ³¨ææååéæ©
		const x = Math.max(1, Math.min(this.selector.startX, this.selector.endX));
		const x1 = Math.min(
			this.tabData.nativeElement.rows[0].cells.length - 1,
			Math.max(this.selector.startX, this.selector.endX)
		);
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		return colIndex >= x && colIndex <= x1 && rowIndex >= y && rowIndex <= y1;
	}
	// æ¯å¦å·¦è¾¹
	cellSelectorLeft(col: number, row: number) {
		if (!this.selector.show) {
			return false;
		}
		const x = Math.min(this.selector.startX, this.selector.endX);
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		return col === x && row >= y && row <= y1;
	}
	// æ¯å¦ä¸è¾¹
	cellSelectorBottom(col: number, row: number) {
		if (!this.selector.show) {
			return false;
		}
		const x = Math.min(this.selector.startX, this.selector.endX);
		const x1 = Math.max(this.selector.startX, this.selector.endX);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		return col >= x && col <= x1 && row === y1;
	}
	// æ¯å¦å³è¾¹
	cellSelectorRight(col: number, row: number) {
		if (!this.selector.show) {
			return false;
		}
		const x1 = Math.max(this.selector.startX, this.selector.endX);
		const y = Math.min(this.selector.startY, this.selector.endY);
		const y1 = Math.max(this.selector.startY, this.selector.endY);
		return col === x1 && row >= y && row <= y1;
	}
	// æ¯å¦ä¸è¾¹
	cellSelectorTop(col: number, row: number) {
		if (!this.selector.show) {
			return false;
		}
		const x = Math.min(this.selector.startX, this.selector.endX);
		const x1 = Math.max(this.selector.startX, this.selector.endX);
		const y = Math.min(this.selector.startY, this.selector.endY);
		return row === y && col >= x && col <= x1;
	}
	cellMouseDown(event: MouseEvent, colIndex: number, rowIndex: number) {
		if (event.button !== 0) {
			return;
		}
		this.leftPressed = true;
		this.selector.show = true;
		this.selector.startX = colIndex;
		this.selector.startY = rowIndex;
		this.selector.endX = colIndex;
		this.selector.endY = rowIndex;
		// Add listeners
		this.closeMouseDownListern = this.renderer.listen('window', 'mousemove', this.onMouseMove);
		this.timer = setInterval(() => {
			if (this.leftPressed) {
				this.scrollTable();
			}
		}, 20);
		// event.preventDefault();
		// event.stopPropagation();
	}
	mouseUp(event: MouseEvent) {
		if (event.button === 0) {
			this.leftPressed = false;
			if (this.closeMouseDownListern) {
				this.closeMouseDownListern();
			}
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
			// event.preventDefault();
			// event.stopPropagation();
		}
	}
	cellMouseEnter(event: MouseEvent) {
		this.current.x = (<HTMLTableCellElement>event.target).cellIndex;
		this.current.y = (<HTMLTableRowElement>(<HTMLTableCellElement>event.target).parentElement).rowIndex;
	}

	onMouseMove(event: MouseEvent) {
		this.x = event.x;
		this.y = event.y;

		if (this.leftPressed) {
			const cell = cellFromPosition(this.tabData.nativeElement, event.x, event.y);
			// éè¦å»æç¬¬ä¸ååæåä¸å
			if (cell.columnIndex === 0) {
				cell.columnIndex = 1;
			}
			if (cell.columnIndex === this.tabData.nativeElement.rows[0].cells.length - 1) {
				cell.columnIndex = cell.columnIndex - 1;
			}
			// éè¦å»æç¬¬ä¸è¡
			if (cell.rowIndex === 0) {
				cell.rowIndex = 1;
			}
			if (cell) {
				this.selector.endX = cell.columnIndex;
				this.selector.endY = cell.rowIndex - 1; // éè¦å»ææ é¢è¡
			}
			this.scrollTable();
		}
	}
	scrollTable() {
		// åç´ å¨ææ¡£çä½ç½®x,y
		const {
			left: xLeft,
			top: yTop,
			right: xRight,
			bottom: yBottom
		} = this.elRef.nativeElement.getBoundingClientRect();
		// å¤æ­é¼ æ æ¯å¦å°åç´ è¾¹ç
		if (this.y <= yTop) {
			// æ»å¨æ¡çä½ç½®
			this.elRef.nativeElement.scrollTop -= yTop - this.y;
		} else if (this.y >= yBottom - 20) {
			this.elRef.nativeElement.scrollTop += this.y - yBottom + 20;
		}

		if (this.x <= xLeft) {
			this.elRef.nativeElement.scrollLeft -= xLeft - this.x;
		} else if (this.x >= xRight) {
			this.elRef.nativeElement.scrollLeft += this.x - xRight;
		}
	}
}
interface CellPosition {
	columnIndex: number;
	rowIndex: number;
	// æ¯å¦è¶åºå¯è§èå´
	outter: boolean;
}
// æ ¹æ®é¼ æ ä½ç½®ï¼è¿åä¸ä¸ªååæ ¼åæ ï¼æ»æ¯è¿åä¸ä¸ªåæ ï¼è¶åºå¯è§åºåèå´çï¼è¿åè¾¹çä¸çåæ 
function cellFromPosition(ele: HTMLTableElement, ox: number, oy: number): CellPosition {
	if (!ele || ele.rows.length === 0) {
		return null;
	}
	const { left, top, bottom, right } = ele.getBoundingClientRect();
	let outter = false;
	let [x, y] = [ox, oy];
	// è¶åºå¯è§åºåï¼ç¨è¾¹çä»£æ¿
	if (ox < left) {
		outter = true;
		x = left;
	} else if (ox > right) {
		outter = true;
		x = right;
	}
	if (oy < top) {
		outter = true;
		y = top;
	} else if (oy > bottom) {
		outter = true;
		y = bottom;
	}
	let colIndex = ele.rows[0].cells.length - 1;
	let rowIndex = ele.rows.length - 1;
	let totalLeft = left,
		totalTop = top;
	// è¡¨æ ¼å¿å®ä¼æä¸è¡,åç¡®å®åä½ç½®
	for (let i = 0; i < ele.rows[0].cells.length; i++) {
		totalLeft += ele.rows[0].cells[i].offsetWidth;
		if (x < totalLeft) {
			colIndex = i;
			break;
		}
	}
	for (let i = 0; i < ele.rows.length; i++) {
		// ä¸ç¨offsetheightï¼é²æ­¢åèäºå¥å¼èµ·ç´¯è®¡åå·®
		const rect = ele.rows[i].getBoundingClientRect();
		totalTop += rect.height;
		if (y < totalTop) {
			rowIndex = i;
			break;
		}
	}
	return { columnIndex: colIndex, rowIndex: rowIndex, outter: outter };
}
